import type { AppModule } from '@/types/architecture'
import routes from './routes'

/**
 * IT Requests Module — Ticketing System
 *
 * Provides an AI-infused IT ticketing system for employees to submit
 * support requests and for IT agents to manage, triage, and resolve them.
 * Includes SLA tracking, template-driven intake forms, canned responses,
 * AI-powered comment rewriting, and full sharing/visibility controls.
 */
const ticketsModule: AppModule = {
    id: 'tickets',
    navigation: {
        label: 'IT Requests',
        icon: 'ticket',
        path: '/tickets',
        order: 45,
        moduleKey: 'it_requests',
        pages: [
            {
                label: 'All Requests',
                path: '/tickets',
                icon: 'ticket',
            },
            {
                label: 'New Request',
                path: '/tickets/create',
                icon: 'ticket-plus',
            },
            {
                label: 'Reports & Analytics',
                path: '/tickets/analytics',
                icon: 'bar-chart-3',
                moduleKey: 'it_requests',
                minAccessLevel: 'full',
            },
            {
                label: 'SLA Dashboard',
                path: '/tickets/sla-dashboard',
                icon: 'gauge',
                moduleKey: 'it_requests',
                minAccessLevel: 'full',
            },
            {
                label: 'Templates',
                path: '/tickets/templates',
                icon: 'file-text',
                moduleKey: 'it_requests',
                minAccessLevel: 'full',
            },
            {
                label: 'Canned Responses',
                path: '/tickets/canned-responses',
                icon: 'message-square-text',
                moduleKey: 'it_requests',
                minAccessLevel: 'full',
            },
            {
                label: 'SLA Policies',
                path: '/tickets/sla-policies',
                icon: 'timer',
                moduleKey: 'it_requests',
                minAccessLevel: 'full',
            },
            {
                label: 'Categories',
                path: '/tickets/categories',
                icon: 'tags',
                moduleKey: 'it_requests',
                minAccessLevel: 'full',
            },
            {
                label: 'Releases',
                path: '/tickets/releases',
                icon: 'rocket',
                moduleKey: 'it_requests',
                minAccessLevel: 'full',
            },
            {
                label: 'MSP Delegation',
                path: '/tickets/msp-delegation',
                icon: 'shield',
                moduleKey: 'it_requests',
                minAccessLevel: 'full',
            },
            {
                label: 'Settings',
                path: '/tickets/settings',
                icon: 'settings',
                moduleKey: 'it_requests',
                minAccessLevel: 'full',
            },
        ],
    },
    routes,
}

export default ticketsModule
